export type EmployeeStatus = 'ACTIVE' | 'INACTIVE' | 'ON_LEAVE' | 'TERMINATED'

export interface Employee {
  id: string
  fullName: string
  designation: string
  contactNumber: string
  branchId: string
  branchName: string
  assignedBranchIds?: string[]
  passportExpiry: string
  visaExpiry: string
  dateOfBirth: string
  nationality: string
  username?: string
  allowLogin: boolean
  picture?: string
  isActive?: boolean
  status: EmployeeStatus
  statusChangedAt?: string
  statusChangedBy?: string
  statusReason?: string
  createdAt?: string
  updatedAt?: string
}

export interface CreateEmployeeRequest {
  fullName: string
  designation: string
  contactNumber: string
  branchId: string
  assignedBranchIds?: string[]
  status?: EmployeeStatus
  passportExpiry?: string
  visaExpiry?: string
  dateOfBirth?: string
  nationality: string
  username?: string
  password?: string
  allowLogin: boolean
  picture?: string | File
  isActive?: boolean
}

export interface UpdateEmployeeRequest extends Partial<CreateEmployeeRequest> {
  id?: string
}

export interface UpdateEmployeeStatusRequest {
  status: EmployeeStatus
  reason?: string
}

export interface BulkUpdateStatusRequest {
  employeeIds: string[]
  status: EmployeeStatus
  reason?: string
}

export interface DocumentExpiryAlert {
  id: string
  fullName: string
  passportExpiry?: string
  visaExpiry?: string
  branch: {
    branchName: string
  }
}

export const designations = [
  'Super Admin',
  'Administrator',
  'Salesman',
  'Production Controller', 
  'Master',
  'Jacket Maker',
  'Trouser Maker',
  'Shirt Maker',
  'Alteration',
  'Reception'
] as const

export type Designation = typeof designations[number]

// Mapping from display names to backend enum values
export const designationToEnum = {
  'Super Admin': 'SUPER_ADMIN',
  'Administrator': 'ADMINISTRATOR',
  'Salesman': 'SALESMAN',
  'Production Controller': 'PRODUCTION_CONTROLLER',
  'Master': 'MASTER',
  'Jacket Maker': 'JACKET_MAKER',
  'Trouser Maker': 'TROUSER_MAKER',
  'Shirt Maker': 'SHIRT_MAKER',
  'Alteration': 'ALTERATION',
  'Reception': 'RECEPTION'
} as const

// Mapping from backend enum values to display names
export const enumToDesignation = {
  'SUPER_ADMIN': 'Super Admin',
  'ADMINISTRATOR': 'Administrator',
  'SALESMAN': 'Salesman',
  'PRODUCTION_CONTROLLER': 'Production Controller',
  'MASTER': 'Master',
  'JACKET_MAKER': 'Jacket Maker',
  'TROUSER_MAKER': 'Trouser Maker',
  'SHIRT_MAKER': 'Shirt Maker',
  'ALTERATION': 'Alteration',
  'RECEPTION': 'Reception'
} as const 
